import React from 'react';

export function TextQuestion({ question, value, onChange }) {
  // Support different input types (text, email, tel, url, etc.)
  const inputType = question.type || 'text';
  const placeholder = question.placeholder || '';

  return (
    <input
      type={inputType}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition text-gray-700"
    />
  );
}
